query getSupplyLayerDepthGroups($groupIds: [String]) {
  getGroups(groupIds: $groupIds) {
    id
    type
    hierarchyIds
    isRootForSource
  }
}

fragment TeamAggregationsFields on TeamAggregations {
  memberCount: memberDescCount
  memberFteSum: memberDescFteSum
  vacancyCount: vacancyDescCount
  agentCount: agentDescCount
  managerCount: managerDescCount
  unassignedCount: unassignedDescCount
  directReportsMin: directReportsDescMin
  directReportsMax: directReportsDescMax
  directReportsAvg: directReportsDescAvg
  directReportsChart: directReportsDescChart {
    points {
      key
      value
    }
  }
  managementLayersMin: manageLayersDescMin
  managementLayersMax: manageLayersDescMax
  managementLayersAvg: manageLayersDescAvg
  managementLayersChart: manageLayersDescChart {
    points {
      key
      value
    }
  }
  externalManagers: extManagersDesc {
    personId
    directReportsCount
  }
  multiTeamOwnerCount: multiTeamOwnerDescCount
  noDirectOwnerCount: noDirectOwnerDescCount
  reportingLineManagerCount: reportLineManagerDescCount
  reportingLineUnassignedCount: reportLineUnassignedDescCount
  reportingLineDirectReportsMin: reportLineDirectReportsDescMin
  reportingLineDirectReportsMax: reportLineDirectReportsDescMax
  reportingLineDirectReportsAvg: reportLineDirectReportsDescAvg
  reportingLineDirectReportsChart: reportLineDirectReportsDescChart {
    points {
      key
      value
    }
  }
  reportingLineManagementLayersMin: reportLineManageLayersDescMin
  reportingLineManagementLayersMax: reportLineManageLayersDescMax
  reportingLineManagementLayersAvg: reportLineManageLayersDescAvg
  reportingLineManagementLayersChart: reportLineManageLayersDescChart {
    points {
      key
      value
    }
  }
}

# Parent metrics — Team Insights + Org Chart / useTeamMetrics (do not rename).
query getTeamAggregations($teamId: ID, $pit: DateTime) {
  aggregations: getAggregations(pit: $pit) {
    team(teamId: $teamId) {
      ...TeamAggregationsFields
    }
  }
}

# Next-level table atoms only (no charts) — FE supplies direct child ids;
# each id resolves like team() (same pit+id DataLoader keys).
fragment TeamAggregationsNextLevelFields on TeamAggregations {
  memberCount: memberDescCount
  memberFteSum: memberDescFteSum
  managerCount: managerDescCount
  unassignedCount: unassignedDescCount
  directReportsMin: directReportsDescMin
  directReportsMax: directReportsDescMax
  directReportsAvg: directReportsDescAvg
  managementLayersMin: manageLayersDescMin
  managementLayersMax: manageLayersDescMax
  managementLayersAvg: manageLayersDescAvg
}

query getTeamsAggregations($teamIds: [ID!]!, $pit: DateTime) {
  aggregations: getAggregations(pit: $pit) {
    teams(teamIds: $teamIds) {
      teamId
      aggregates {
        ...TeamAggregationsNextLevelFields
      }
    }
  }
}

query getChildTeamsInsights($teamId: String!, $comparisonDate: Date) {
  team: getGroup(groupId: $teamId) {
    id
    name
    childTeams(comparisonDate: $comparisonDate) {
      id
      name
      type
      directParentId
      parentIds
      hierarchy
      hierarchyIds
      isHidden
      isDeleted
      memberCount
      directMemberCount
      directChildTeamCount
      attributes {
        id
        attributeType
        subtype
        label
        value
      }
    }
  }
}
